var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.802.227c.247.145.453.354.596.605l8.382 14.685a1.671 1.671 0 01-.595 2.265 1.614 1.614 0 01-.818.223H1.633A1.645 1.645 0 010 16.347c0-.29.075-.576.219-.828L8.57.834a1.62 1.62 0 012.23-.607zM9.783 1.544L1.431 16.23a.24.24 0 00-.031.118c0 .131.104.237.233.237h16.734a.23.23 0 00.117-.032.239.239 0 00.085-.323L10.187 1.544a.235.235 0 00-.06-.07l-.025-.016-.024-.013a.232.232 0 00-.295.1zm.22 11.488c.58 0 1.05.477 1.05 1.066 0 .588-.47 1.066-1.05 1.066-.58 0-1.05-.478-1.05-1.066 0-.589.47-1.066 1.05-1.066zm0-6.393a.94.94 0 01.932.947v3.315a.94.94 0 01-.933.947.94.94 0 01-.933-.947V7.586a.94.94 0 01.933-.947z"
  })));
}

export default SvgAlert;